export default "__VITE_ASSET__hUlv5W_S__"